import React, { useRef, useState } from 'react';
import { TextField, Typography, InputAdornment, Checkbox, withStyles, Snackbar } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import { useDispatch } from 'react-redux';
import { addDocter } from '../../store/actions/dokterAction';
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import Autocomplete from '@material-ui/lab/Autocomplete';
import search from '../../assets/ic_date.png';
import bg_notif from '../../assets/bg_notif.png';
import ic_edit from '../../assets/1@3x.png';
import circle from '../../assets/circle.png';
import print from '../../assets/ic_print.png';
import ic_checkmark from '../../assets/ic_checkmark.png';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import ImageUploader from 'react-images-upload';
import line from '../../assets/line grey.png';
import ic_search from '../../assets/ic_search.png';
import api from '../api';
import { useHistory, useLocation } from 'react-router-dom';
import { ComponentToPrint } from './ComponentToPrint';
import { format } from 'date-fns';
import MuiAlert from '@material-ui/lab/Alert';
import { __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED } from 'react-dom/cjs/react-dom.development';
import { camelize } from '../../library/Util';

const pageStyle = `{size: 3.075in 10.25in}`;

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const CustomCheckbox = withStyles({
    root: {
        color: '#2a9c6c',
        '&$checked': {
            color: '#2a9c6c',
        },
        padding: 5,
        borderRadius: 20,
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default function PopUpDetailHistoryReservasi(props) {
    const componentRef = useRef()
    const history = useHistory()
    const location = useLocation()
    const tempData = props.data
    const doctor_schedule_id = props.emergency.doctor_schedule_detail_id
    const doctor_schedule_detail_id = props.emergency.doctor_schedule_id
    const id = props.data.appointment_id
    const is_emergency = props.is_emergency
    // console.log(is_emergency === null);
    // console.log(data);
    const dateAndTime = new Date(tempData.appointment_date)
    const a = dateAndTime.getDate()
    let b = dateAndTime.getMonth() + 1
    const c = dateAndTime.getFullYear()
    switch (b) {
        case 1:
            b = "Jan"
            break;
        case 2:
            b = "Feb"
            break;
        case 3:
            b = "Mar"
            break;
        case 4:
            b = "Apr"
            break;
        case 5:
            b = "Mei"
            break;
        case 6:
            b = "Jun"
            break;
        case 7:
            b = "Jul"
            break;
        case 8:
            b = "Aug"
            break;
        case 9:
            b = "Sep"
            break;
        case 10:
            b = "Oct"
            break;
        case 11:
            b = "Nov"
            break;
        default:
            b = "Des"
            break;
    }
    const displayDate = `${a} ${b} ${c}, ${String(tempData.time_start).slice(0, 5)} - ${String(tempData.time_end).slice(0, 5)}`
    let defaultValue = null
    const dispatch = useDispatch();
    const [uploadVisible, setUploadVisible] = useState(false)
    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [pictures, setPicture] = useState([])
    const [status, setStatus] = React.useState(false)
    const [dataPoli, setDataPoli] = React.useState([])
    const [data, setData] = React.useState(tempData)
    const [visibleListPoli, setVisibleSetListPoli] = React.useState(false)
    const [loading, setLoading] = React.useState(false);
    const [visibleEmergency, setVisibleEmergency] = React.useState(false);
    const [visibleBatal, setVisibleBatal] = React.useState(false);
    const [visibleEdit, setVisibleEdit] = React.useState(false);
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const [tanggal, setTanggal] = React.useState(tempData.appointment_date);
    const [room, setRoom] = React.useState(null)
    const [alasanBatal, setAlasanBatal] = React.useState(null)
    const [idDokter, setIdDokter] = React.useState(null);
    const [selectedId, setSelectedId] = React.useState(null);
    const [timeId, setTimeId] = React.useState(null);
    const [slotWaktu, setSlotWaktu] = React.useState([]);
    const [timeslot, setTimeslot] = React.useState([]);
    const [timeValue, setTimeValue] = React.useState([]);
    // const [timeslowt, setTimeslot] = React.useState([]);
    const [pasienSchedule, setPasienSchedule] = React.useState(tempData.patient_schedule);
    const [paymentMethod, setPaymentMethod] = React.useState(tempData.payment_option_id);
    const [visibleCheckIn, setVisibleCheckIn] = React.useState(false);
    const [visibleCheckInReservation, setVisibleCheckInReservation] = React.useState(false);
    const [visibleCatatanPetugas, setVisibleCatatanPetugas] = React.useState(false);
    const [visiblePrint, setVisiblePrint] = React.useState(false);
    const [expand, setExpand] = React.useState(false);
    const [buttonEdit, setButtonEdit] = React.useState(false);
    const [visibleJadwal, setVisibleJadwal] = React.useState(false);

    const [reservasiVia, setReservasiVia] = useState("")
    const [noRujukan, setNoRujukan] = React.useState("")
    const [namaPasienBPJS, setNamaPasienBPJS] = React.useState("")
    const [namaPasienAsuransi, setNamaPasienAsuransi] = React.useState("")
    const [noKartuBPJS, setNoKartuBPJS] = React.useState("-")
    const [noKartuAsuransi, setNoKartuAsuransi] = React.useState("-")
    const [errorRujukan, setErrorRujukan] = React.useState(false)
    const [textErrorRujukan, setTextErrorRujukan] = React.useState("")
    const [listProvider, setListProvider] = React.useState([])
    const [provider, setProvider] = React.useState(null)
    const [pickAsuransi, setPickAsuransi] = React.useState(null)
    const [arrayAsuransi, setArrayAsuransi] = React.useState([])
    const [visibleOpenPendukung, setVisibleOpenPendukung] = React.useState(false)
    const [categoryProvider, setCategoryProvider] = React.useState([])
    const [pickCategory, setPickCategory] = React.useState(null)
    const [categoryDetail, setCategoryDetail] = React.useState("-");
    const [detailDokter, setDetailDokter] = React.useState(null);
    const [disableButton, setDisableButton] = React.useState(false)
    const [visibleNotes, setVisibleNotes] = React.useState(false);
    const [errorForce, setErrorForce] = useState(false)
    const [generatedSEP, setGeneratedSEP] = useState(0)

    const [newDocter, setnewDocter] = React.useState({
        kodeDokter: "",
        spesialisDokter: "",
        alamat: "",
        durasiperiksa: "",
        namaDokter: "",
        poliklinik: "",
        pengalamanDokter: ""
    })
    const handleOnChange = (e) => {
        const { name, value } = e.target
        setnewDocter({
            ...newDocter,
            [name]: value
        })
    }

    const dummyList = [
        { name: 'tes' },
        { name: 'tes' },
        { name: 'tes' },
    ]

    React.useEffect(() => {
        console.log(tempData);
        // getTimeSlot(data.payment_option_id, data.appointment_date)
        setLoading(true)
        setPasienSchedule(data.patient_schedule)
        getData(id)
    }, [])


    const getCategoryByProvider = (code) => {
        let payload = {
            "business_partner_code": code
        }
        api.create().getProviderByCode(payload).then(response => {
            if (response.data) {
                if (response.data.status === true) {
                    let type = String(response.data.data.type).toUpperCase()
                    setCategoryDetail(type)
                    forceUpdate()
                }
            }
        })
    }

    React.useEffect(() => {
        getTimeSlot(paymentMethod && paymentMethod.id, format(new Date(tanggal), 'yyyy-MM-dd'))
    }, [tanggal, paymentMethod])

    const getData = (id) => {
        api.create().getDetailReservasiDokter(id).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setData(response.data.data)
                    getCategoryByProvider(data.patient.provider_code)
                    setButtonEdit(data.appointment_status_id === 6 ? true : false)
                    let indexPayment = listPaymentOption.findIndex((val) => val.name === data.payment_option_id)
                    // console.log(indexPayment);
                    if (slotWaktu != false) {
                        let indexSlotWaktu = slotWaktu.findIndex((val) => val.time === pasienSchedule)
                        setPasienSchedule(slotWaktu[indexSlotWaktu])
                        setTimeId(slotWaktu[indexSlotWaktu])
                    }
                    setPasienSchedule(data.patient_schedule)
                    setNoKartuAsuransi(data.patient.insurance_no)
                    setNamaPasienAsuransi(data.patient.card_name)
                    setNamaPasienBPJS(data.patient.bpjs_name)
                    setNoKartuBPJS(data.patient.bpjs_no)
                    setNoRujukan(data.reference_no)
                    setReservasiVia(data.reservation_from)
                    getCategoryProvider()
                    getDataPoli()
                    getJadwalPeriksa()
                    if(data.sep_integration != null){
                        setGeneratedSEP(data.sep_integration)
                        
                    }
                }
            }
        })
    }

    const postUpdateSEP = () => {
        api.create().postUpdateSEP({'sep_no':data.sep_no}).then(response => {
            console.log('PRINT SEP');
            console.log(JSON.stringify(response));
            if (response.data) {
                if (response.data.status === true) {
                    setGeneratedSEP(response.data.data.sep_integration)
                    // getData(id)
                    forceUpdate()
                } else {
                    if (response.data.data) {
                        if (response.data.data.includes("Apakah anda yakin")) {
                            setErrorForce(true)
                            setErrorMessage(response.data.data)
                        } else {
                            setError(true)
                            setErrorMessage(response.data.data)
                        }
                    }
                }
            }
        })
    }

    const getCategoryProvider = () => {
        api.create().getCategoryProvider().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setCategoryProvider(response.data.data)
                    forceUpdate()
                }
            }
        })
    }

    const getProviderByCode = (code) => {
        let payload = {
            "business_partner_code": code ? code : data.patient.provider_code,
        }
        api.create().getProviderByCode(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.message === "Data not found!") {
                        setPickCategory(null)
                        setProvider(null)
                        forceUpdate()
                    } else {
                        let idCat = categoryProvider.findIndex((val) => val.type === response.data.data.type)
                        console.log(idCat);
                        if (idCat > -1) {
                            setPickCategory(categoryProvider[idCat])
                            getProviderByCategory(response.data.data.type, response.data.data.code)
                            forceUpdate()
                        }
                    }
                }
            }
        })
    }

    const getProviderByCategory = (type, code) => {
        api.create().getProviderByCategory(type).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setListProvider(response.data.data)
                    let idProv = response.data.data.findIndex((val) => val.code === code)
                    if (idProv > -1) {
                        setProvider(response.data.data[idProv])
                        forceUpdate()
                    }
                    forceUpdate()
                }
            }
            setLoading(false)
        })
    }


    const getTimeSlot = (payment, date) => {
        // console.log(payment, date, '----------------');
        let params = `polyclinic_id=${data.polyclinic.id}&date=${format(new Date(tanggal), 'yyyy-MM-dd')}&id=${data.doctor.id}&payment_type=${paymentMethod ? paymentMethod.id : data.payment_option_id}`
        // console.log(params);
        api.create().getTimeSlot(params).then(response => {
            console.log(response);
            console.log(data);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.length > 0) {
                        setTimeslot(response.data.data[0].schedule)
                        let idxSchedule = response.data.data[0].schedule.findIndex((val) => val.id === data.doctor_schedule_id)
                        if (idxSchedule > -1) {
                            setTimeValue(idxSchedule)
                            getDetailTimeSlot(response.data.data[0].schedule[idxSchedule], idxSchedule)
                            setVisibleJadwal(true)
                        }
                        setDisableButton(false)
                    } else {
                        setVisibleJadwal(false)
                        setDisableButton(true)
                        setTimeslot([])
                        setPasienSchedule(null)
                    }
                } else {
                    setVisibleJadwal(false)
                    setDisableButton(true)
                    setTimeslot([])
                    setPasienSchedule(null)
                }
            }
        })
        forceUpdate()
    }

    React.useEffect(() => {
        getDataPoli()
        getJadwalPeriksa(tanggal)
        // getTimeSchedule()
        let indexPayment = listPaymentOption.findIndex((val) => val.name === data.payment_option_id)
        setPaymentMethod(listPaymentOption[indexPayment])
        forceUpdate()
    }, [])

    const handlePaymentOption = () => {
        let indexPayment = listPaymentOption.findIndex((val) => val.id === data.payment_option_id)
        console.log(indexPayment);
        setPaymentMethod(listPaymentOption[indexPayment])
        forceUpdate()
    }

    const getDetailTimeSlot = (elemen, index) => {
        setDetailDokter(elemen)
        if (elemen.is_leave == 1) {
            setDisableButton(true)
            forceUpdate()
        } else if (elemen.is_holiday == 1) {
            setDisableButton(true)
            forceUpdate()
        } else if (elemen.is_stop == 1) {
            setDisableButton(true)
            forceUpdate()
        } else {
            setDisableButton(false)
            forceUpdate()
        }
        console.log(elemen, index);
        let temp = []
        elemen.detail_schedule.map((el, idx) => {
            if (el.is_available === 1) {
                temp.push({
                    time: `${el.detail_time_start.slice(0, 5)} - ${el.detail_time_end.slice(0, 5)} (Tersedia)`,
                    id: el.id
                })
            } else {
                temp.push({
                    time: `${el.detail_time_start.slice(0, 5)} - ${el.detail_time_end.slice(0, 5)} (Tidak Tersedia)`,
                    id: el.id
                })

            }
        })
        if (elemen.time_type === "FIFO") {
            setPasienSchedule(temp[0])
            setTimeId(temp[0].id)
            forceUpdate()
        } else {
            let idxDetail = temp.findIndex((val) => val.id === data.doctor_schedule_detail_id)
            if (idxDetail > -1) {
                console.log(temp[idxDetail]);
                setPasienSchedule(temp[idxDetail])
                setTimeId(temp[idxDetail].id)
                forceUpdate()
            }
        }
        setSlotWaktu(temp)
    }

    const handleButton = (item) => {
        if (item.is_holiday === 1) {
            setDisableButton(true)
        } else {
            setDisableButton(false)
        }
    }

    const getListAsuransi = (rm, without) => {
        api.create().getListAsuransi(rm, without).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    let array = []
                    if (data.patient_insurances.length > 0) {
                        data.patient_insurances.map((item, index) => {
                            array.push(item)
                        })
                        setArrayAsuransi(array)
                        setVisibleOpenPendukung(true)
                        console.log(array);
                        forceUpdate()
                    } else {
                        setArrayAsuransi([])
                    }
                }
            }
        })
    }

    const getJadwalPeriksa = (date) => {
        let formatPlusWeek = new Date(new Date(tanggal).setDate(new Date(tanggal).getDate() + 7))
        const id = data.doctor.id
        let params = `date_filter={"schedule_date": {"start":${date}-${new Date(tanggal).getDate()},"end":${new Date(formatPlusWeek).getFullYear()}-${new Date(formatPlusWeek).getMonth() + 1}-${new Date(formatPlusWeek).getDate()}}}&filter={"doctor_id":[${id}]}`
        let tempId;
        let selectedDate = data.doctor_schedule
        if (date !== undefined) {
            selectedDate = format(new Date(date), 'yyyy-MM-dd')
        }

        api.create().filterDokter(params).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.length > 0) {
                        let schedule = response.data.data[0].polyclinic[0].schedule
                        let idx = schedule.findIndex((val) => val.date === tanggal)
                        if (idx !== -1) {
                            getTimeSchedule(schedule[idx].id)
                            setRoom(schedule[idx].room)
                        }

                    }
                }
            }

        })
    }

    const getTimeSchedule = (idDokter) => {
        api.create().getTimeslotDokter(idDokter).then(response => {
            console.log(response, '----------------');
            if (response.data.data) {
                let temp = []
                response.data.data[0].detail.map((el, idx) => {
                    if (el.is_available === 1) {
                        temp.push({
                            time: `${el.detail_time_start.slice(0, 5)} - ${el.detail_time_end.slice(0, 5)} (Tersedia)`,
                            id: el.id
                        })
                    } else {
                        temp.push({
                            time: `${el.detail_time_start.slice(0, 5)} - ${el.detail_time_end.slice(0, 5)} (Tidak Tersedia)`,
                            id: el.id
                        })
                    }
                })
                setSlotWaktu(temp)
            }
        })
    }

    const getDataPoli = () => {
        api.create().getListMasterPoli().then(response => {
            console.log(response);
            if (response.data) {
                setDataPoli(response.data.data)
            }
            setLoading(false)
        })
    }

    const onDrop = (pictureFiles, pictureDataURLs) => {
        // console.log(pictureDataURLs, '----------------1');
        // console.log(pictureFiles);
        // setPhoto(pictureDataURLs)
        // setPicture(pictureFiles)
        // console.log(response);
        // console.log(pictureDataURLs);
        // this.setState({
        //     pictures: this.state.pictures.concat(pictureFiles),
        // });
    }

    const uploadFoto = () => {
        // console.log(pictures[0].name, '================2');
        // api.create().uploadFoto(pictures[0].name).then(response => {
        //     console.log(response);
        // })
        setUploadVisible(false)
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleDaftar = () => {
        setStatus(true)
    }

    const handleClose = () => {
        setVisibleSetListPoli(false)
        setOpenAlert(false)
    }

    const handleCheked = (index) => {
        console.log(index);
        let a = dataPoli[index].checked = !dataPoli[index].checked
        console.log(dataPoli[index]);
        forceUpdate()
    }

    const handleEmergency = () => {
        setVisibleEmergency(true)
    }

    const handleBatal = () => {
        setVisibleBatal(true)
    }

    const onClose = () => {
        setVisibleEmergency(false)
        setVisibleBatal(false)
        setVisibleCheckIn(false)
        setVisibleCheckInReservation(false)
    }

    const changeStatus = () => {
        let payload = {
            "appointment_id": data.appointment_id,
            "reasons": alasanBatal,
            "is_admin": true
        }
        api.create().cancelReservation(payload).then(response => {
            console.log(response);
            if (response.data.message === "Success canceled appointment!") {
                setVisibleBatal(false)
                setOpenAlert(true)
                setMessageAlert(response.data.message)
                setStatusAlert("Succes")
                setTimeout(() => {
                    history.goBack()
                }, 1000)
            }
        })
    }

    const submitEmergency = () => {
        let payload = {
            "doctor_schedule_id": doctor_schedule_detail_id, // kebalik
            "doctor_schedule_detail_id": doctor_schedule_id,
        }
        console.log(payload);
        api.create().emergencyReservation(payload).then(response => {
            console.log(response);
            if (response.data.message === "Doctor queue successfully updated to emergency status!") {
                setVisibleEmergency(false)
                setOpenAlert(true)
                setMessageAlert("Antrian dokter berhasil di perbarui")
                setStatusAlert("Succes")
                setTimeout(() => {
                    history.goBack()
                }, 2500)
            }
        })
    }

    const submitCheckIn = () => {
        let payload = {
            'appointment_id': data.appointment_id,
            'is_admin': 1
        }
        console.log(payload)
        api.create().checkIn(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.message)
                        setStatusAlert("Succes")
                        setTimeout(() => {
                            setVisibleCheckIn(false)
                        }, 100)
                    }
                }
            }
        })
    }

    const submitCheckInDanRegis = () => {
        let payload = {
            'appointment_id': data.appointment_id,
            'is_admin': 1,
            'with_registration': 1,
        }
        api.create().checkIn(payload).then(response => {
            console.log(response);
            if (response.data.data) {
                setOpenAlert(true)
                setMessageAlert(response.data.message)
                setStatusAlert("Succes")
                setTimeout(() => {
                    setVisibleCheckInReservation(false)
                }, 100)
            }
        })
    }

    const listPaymentOption = [
        {
            id: 1,
            name: "Umum"
        },
        {
            id: 2,
            name: "Asuransi"
        },
        {
            id: 3,
            name: "Bpjs"
        },
    ]

    const doEdit = () => {
        if (paymentMethod) {
            if (paymentMethod.id === 3) {
                if (noRujukan === "") {
                    setErrorRujukan(true)
                    setTextErrorRujukan("No Rujukan wajib diisi")
                } else {
                    let payload = {
                        "appointment_id": data.appointment_id,
                        "doctor_schedule_detail_id": pasienSchedule ? pasienSchedule.id : null,
                        "is_admin": true,
                        "payment_option": paymentMethod !== undefined ? paymentMethod.id : data.payment_option_id,
                        "reference_no": noRujukan,
                        "patient_bpjs_no": noKartuBPJS,
                        "patient_bpjs_name": namaPasienBPJS
                    }
                    console.log(payload);
                    api.create().reschedule(payload).then(response => {
                        console.log(response);
                        if (response.data) {
                            if (response.data.status === true) {
                                setMessageAlert(response.data.message)
                                setStatusAlert(true)
                                setVisibleEdit(false)
                                getData(id)
                                forceUpdate()
                            } else {
                                if (response.data.data) {
                                    if (String(response.data.data).includes("anda yakin buat reservasi baru?")) {
                                        setErrorForce(true)
                                        setErrorMessage(response.data.data)
                                    } else {
                                        setError(true)
                                        setErrorMessage(response.data.data)
                                    }
                                }
                            }
                        }
                    })
                }
            } else if (paymentMethod.id === 2) {
                let payload = {
                    "appointment_id": data.appointment_id,
                    "doctor_schedule_detail_id": pasienSchedule ? pasienSchedule.id : null,
                    "is_admin": true,
                    "payment_option": paymentMethod !== undefined ? paymentMethod.id : data.payment_option_id,
                    "patient_insurance_no": noKartuAsuransi,
                    "patient_insurance_card_name": namaPasienAsuransi,
                    "patient_provider_code": provider ? provider.code : null,
                    "patient_insurance_name": provider ? provider.name : null,
                    "patient_insurance_id": pickAsuransi === null ? null : pickAsuransi.insurance_no
                }
                console.log(payload);
                api.create().reschedule(payload).then(response => {
                    console.log(response);
                    if (response.data) {
                        if (response.data.status === true) {
                            setMessageAlert(response.data.message)
                            setStatusAlert(true)
                            setVisibleEdit(false)
                            getData(id)
                            forceUpdate()
                        } else {
                            if (response.data.data) {
                                setError(true)
                                setErrorMessage(response.data.data)
                            }
                        }
                    }
                })
            } else {
                let payload = {
                    "appointment_id": data.appointment_id,
                    "doctor_schedule_detail_id": pasienSchedule ? pasienSchedule.id : null,
                    "is_admin": true,
                    "payment_option": paymentMethod !== undefined ? paymentMethod.id : data.payment_option_id
                }
                console.log(payload);
                api.create().reschedule(payload).then(response => {
                    console.log(response);
                    if (response.data) {
                        if (response.data.status === true) {
                            setMessageAlert(response.data.message)
                            setStatusAlert(true)
                            setVisibleEdit(false)
                            getData(id)
                            forceUpdate()
                        } else {
                            if (response.data.data) {
                                if (response.data.data.includes("Apakah anda yakin?")) {
                                    setErrorForce(true)
                                    setErrorMessage(response.data.data)
                                } else {
                                    setError(true)
                                    setErrorMessage(response.data.data)
                                }
                            }
                        }
                    }
                })
            }
        }
    }

    const handleForceReschedule = () => {
        if (paymentMethod) {
            if (paymentMethod.id === 3) {
                if (noRujukan === "") {
                    setErrorRujukan(true)
                    setTextErrorRujukan("No Rujukan wajib diisi")
                } else {
                    let payload = {
                        "appointment_id": data.appointment_id,
                        "doctor_schedule_detail_id": pasienSchedule ? pasienSchedule.id : null,
                        "is_admin": true,
                        "payment_option": paymentMethod !== undefined ? paymentMethod.id : data.payment_option_id,
                        "reference_no": noRujukan,
                        "patient_bpjs_no": noKartuBPJS,
                        "patient_bpjs_name": namaPasienBPJS,
                        "force_reschedule": 1
                    }
                    console.log(payload);
                    api.create().reschedule(payload).then(response => {
                        console.log(response);
                        if (response.data) {
                            if (response.data.status === true) {
                                setMessageAlert(response.data.message)
                                setStatusAlert(true)
                                setVisibleEdit(false)
                                setErrorForce(false)
                                getData(id)
                                forceUpdate()
                            } else {
                                if (response.data.data) {
                                    if (String(response.data.data).includes("anda yakin buat reservasi baru?")) {
                                        setErrorForce(true)
                                        setErrorMessage(response.data.data)
                                    } else {
                                        setError(true)
                                        setErrorForce(false)
                                        setErrorMessage(response.data.data)
                                    }
                                }
                            }
                        }
                    })
                }
            } else if (paymentMethod.id === 2) {
                let payload = {
                    "appointment_id": data.appointment_id,
                    "doctor_schedule_detail_id": pasienSchedule ? pasienSchedule.id : null,
                    "is_admin": true,
                    "payment_option": paymentMethod !== undefined ? paymentMethod.id : data.payment_option_id,
                    "patient_insurance_no": noKartuAsuransi,
                    "patient_insurance_card_name": namaPasienAsuransi,
                    "patient_provider_code": provider ? provider.code : null,
                    "patient_insurance_name": provider ? provider.name : null,
                    "patient_insurance_id": pickAsuransi === null ? null : pickAsuransi.insurance_no,
                    "force_reschedule": 1
                }
                console.log(payload);
                api.create().reschedule(payload).then(response => {
                    console.log(response);
                    if (response.data) {
                        if (response.data.status === true) {
                            setMessageAlert(response.data.message)
                            setStatusAlert(true)
                            setVisibleEdit(false)
                            setErrorForce(false)
                            getData(id)
                            forceUpdate()
                        } else {
                            if (response.data.data) {
                                setError(true)
                                setErrorMessage(response.data.data)
                            }
                        }
                    }
                })
            } else {
                let payload = {
                    "appointment_id": data.appointment_id,
                    "doctor_schedule_detail_id": pasienSchedule ? pasienSchedule.id : null,
                    "is_admin": true,
                    "payment_option": paymentMethod !== undefined ? paymentMethod.id : data.payment_option_id,
                    "force_reschedule": 1
                }
                console.log(payload);
                api.create().reschedule(payload).then(response => {
                    console.log(response);
                    if (response.data) {
                        if (response.data.status === true) {
                            setMessageAlert(response.data.message)
                            setStatusAlert(true)
                            setVisibleEdit(false)
                            setErrorForce(false)
                            getData(id)
                            forceUpdate()
                        } else {
                            if (response.data.data) {
                                setError(true)
                                setErrorMessage(response.data.data)
                            }
                        }
                    }
                })
            }
        }
    }

    const getPrintSEP = () => {
        api.create().getPrintSEP({"appointment_id": data.appointment_id}).then(response => {
            if (response.data) {
                console.log()
                if (response.data.status === true) {
                    if(response.data.data.print_url){
                        window.open(response.data.data.print_url, '_blank')
                    }
                } else {
                    if (response.data.data) {
                        if (response.data.data.includes("Apakah anda yakin")) {
                            setErrorForce(true)
                            setErrorMessage(response.data.data)
                        } else {
                            setError(true)
                            setErrorMessage(response.data.data)
                        }
                    }
                }
            }
        })
    }

    return (
        <div className="App app-popup-show">
            <Snackbar open={openAlert} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div className="popup-content-full background-white">
                <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 30, borderTopLeftRadius: 30, backgroundColor: '#f5f5f5' }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Detail Reservasi</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>
                {
                    !loading && visibleEdit ?
                        <div style={{ height: '88vh', overflow: 'auto', padding: 20 }}>
                            <div style={{ marginTop: 20 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', }}>
                                    <Typography style={{ fontWeight: '500', fontSize: 20 }}>Data Reservasi</Typography>
                                </div>
                                {
                                    data.appointment_status_name !== "Cancel" ?
                                        <div className="grid grid-2x grid-mobile-none" style={{ padding: '0px 20px 20px 20px', }}>
                                            <div className="column-1">
                                                <div className="">
                                                    <Autocomplete
                                                        style={{ width: '85%' }}
                                                        options={listPaymentOption}
                                                        getOptionLabel={(option) => option.name}
                                                        disableClearable
                                                        name='Opsi Pembayaran'
                                                        id="payment"
                                                        placeholder="pilih opsi pembayaran"
                                                        defaultValue="pilih opsi pembayaran"
                                                        onChange={(event, newInputValue) => {
                                                            setPaymentMethod(newInputValue)
                                                            forceUpdate()
                                                        }}
                                                        value={paymentMethod}
                                                        renderInput={(params) =>
                                                            <TextField
                                                                {...params}
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    style: {
                                                                        fontSize: 14,
                                                                    },
                                                                    disableUnderline: true
                                                                }}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        color: '#7e8085',
                                                                    }
                                                                }}
                                                                label="Opsi Pembayaran"
                                                            />
                                                        }
                                                    />
                                                </div>
                                                <div style={{ textAlign: 'left' }}>
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                                        <DatePicker
                                                            margin="normal"
                                                            id="validFrom"
                                                            label="Tanggal"
                                                            format="dd MMM yyyy"
                                                            defaultValue="Pilih tanggal dan waktu"
                                                            value={tanggal}
                                                            minDate={new Date()}
                                                            onChange={(date) => {
                                                                setTanggal(date)
                                                                setTimeValue(null)
                                                                setVisibleJadwal(false)
                                                                forceUpdate()
                                                            }}
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change date',
                                                            }}
                                                            InputProps={{
                                                                style: {
                                                                    fontSize: 14,
                                                                }
                                                            }}
                                                            InputLabelProps={{
                                                                style: {
                                                                    color: '#7e8085',
                                                                }
                                                            }}
                                                            inputProps={{
                                                                style: {
                                                                    color: 'black'
                                                                }
                                                            }}
                                                            style={{ width: '85%' }}
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                </div>
                                                <div className="card" style={{ border: 'none' }}>
                                                    <Typography style={{ fontSize: '11px', color: '#a5a5a5', marginTop: timeslot == false ? 10 : 2, textAlign: 'left' }}>Pilih Sesi Periksa</Typography>
                                                    <div style={{ display: 'flex', marginTop: 5, textAlign: 'center' }}>
                                                        {timeslot == false ?
                                                            <div>
                                                                <Typography>Jadwal Tidak Tersedia</Typography>
                                                            </div>
                                                            :
                                                            timeslot.map((el, idx) => {
                                                                // console.log(el);
                                                                // console.log(data);
                                                                return (
                                                                    <div style={{ marginLeft: 20, cursor: 'pointer', width: 152, maxHeight: 30, minHeight: 30, borderRadius: 16, backgroundColor: timeValue === idx || el.detail_time_start === data.time_start ? "#2A9C6C" : 'white', border: timeValue === idx || el.detail_time_start === data.time_start ? '1px solid white' : '1px solid #34b68b', color: timeValue === idx || el.detail_time_start === data.time_start ? "white" : 'black' }}
                                                                        onClick={() => {
                                                                            setTimeValue(idx)
                                                                            // setSelectedId(el.id)
                                                                            setVisibleJadwal(true)
                                                                            setPasienSchedule(null)
                                                                            getDetailTimeSlot(el, idx)
                                                                            handleButton(el)
                                                                            // getTimeSchedule(el)
                                                                            // set_visible_time_schedule(false)
                                                                            forceUpdate()
                                                                        }}
                                                                    >
                                                                        <Typography>{`${el.time_start.slice(0, 5)} - ${el.time_end.slice(0, 5)}`}</Typography>
                                                                    </div>
                                                                )
                                                            })}
                                                    </div>
                                                </div>
                                                {detailDokter !== null && (
                                                    <div style={{ marginTop: 20 }}>
                                                        <Typography style={{ textAlign: 'left', fontSize: '12px' }}>{detailDokter.is_leave === 1 || detailDokter.is_holiday === 1 ? detailDokter.notes : detailDokter.remarks === null ? '-' : detailDokter.remarks}</Typography>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="column-2">
                                                <div className="" style={{ textAlign: 'left' }}>
                                                    <TextField
                                                        style={{ width: '85%', cursor: 'pointer', marginTop: 1 }}
                                                        // onClick={() => setVisibleSetListPoli(true)}
                                                        name='Opsi Pembayaran'
                                                        id="payment"
                                                        label="Klinik"
                                                        defaultValue="Pilih Klinik"
                                                        value={`Poliklinik ${data.polyclinic.name}`}
                                                        // onChange={(event, newInputValue) => {
                                                        //     // setPoliklinik(newInputValue)
                                                        // }}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: '#7e8085',
                                                            }
                                                        }}
                                                        disabled={true}
                                                        inputProps={{
                                                            style: {
                                                                color: 'black'
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div className="" style={{ textAlign: 'left' }}>
                                                    <TextField
                                                        style={{ width: '85%', marginTop: 17 }}
                                                        id="namaDokter"
                                                        name="namaDokter"
                                                        label="Nama Dokter"
                                                        value={data.doctor.name}
                                                        onChange={(e) => {
                                                            // handleOnChange(e)
                                                            // setErrorKodeDokter(true)
                                                            // setTextKodeDokter("")
                                                        }}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: '#7e8085',
                                                            }
                                                        }}
                                                        disabled={true}
                                                        inputProps={{
                                                            style: {
                                                                color: 'black'
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                {visibleJadwal && (
                                                    <div className="">
                                                        <Autocomplete
                                                            style={{ width: '85%', marginTop: 8 }}
                                                            options={slotWaktu}
                                                            getOptionLabel={(option) => option.time}
                                                            disableClearable
                                                            name='jadwal Periksa'
                                                            id="payment"
                                                            placeholder="pilih jadwal periksa"
                                                            defaultValue="pilih jadwal periksa"
                                                            onChange={(event, newInputValue) => {
                                                                setPasienSchedule(newInputValue)
                                                                setTimeId(newInputValue.id)
                                                            }}
                                                            value={pasienSchedule}
                                                            renderInput={(params) =>
                                                                <TextField
                                                                    {...params}
                                                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                                                    label="Jadwal Periksa"
                                                                />
                                                            }
                                                        />
                                                    </div>
                                                )}
                                                <div>
                                                    <TextField
                                                        style={{ width: '100%', marginTop: 10 }}
                                                        disabled={true}
                                                        multiline
                                                        maxRows={2}
                                                        rows={2}
                                                        InputProps={{
                                                            disableUnderline: true,
                                                            style: {
                                                                color: 'black'
                                                            }
                                                        }}
                                                        inputProps={{
                                                            style: {
                                                                letterSpacing: 1.5, color: '#a4a4a4', fontSize: 14
                                                            }
                                                        }}
                                                        value={detailDokter !== null ? detailDokter.doctor_notes : ""}
                                                    />
                                                    {detailDokter && detailDokter.doctor_notes && detailDokter.doctor_notes.length > 20 && (
                                                        <div style={{ width: '85%', display: 'flex', justifyContent: 'flex-end', cursor: 'pointer' }}
                                                            onClick={() => {
                                                                setVisibleNotes(true)
                                                            }}
                                                        >
                                                            <Typography style={{ color: '#37a7ed', fontSize: 12 }}>Lihat Detail</Typography>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="grid grid-2x grid-mobile-none" style={{ padding: '10px 20px 20px 20px', }}>
                                            <div className="column-1">
                                                <div className="">
                                                    <TextField
                                                        style={{ width: '85%', borderBottom: 'none !important' }}
                                                        id="opsiPembayaran"
                                                        name="opsiPembayaran"
                                                        label="Opsi Pembayaran"
                                                        value={data.payment_option_name}
                                                        onChange={(e) => {
                                                            // handleOnChange(e)
                                                            // setErrorKodeDokter(false)
                                                            // setTextKodeDokter("")
                                                        }}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: '#7e8085',
                                                            }
                                                        }}
                                                        inputProps={{
                                                            style: {
                                                                color: 'black'
                                                            }
                                                        }}
                                                        disabled={true}
                                                    />
                                                </div>
                                                <div style={{ textAlign: 'left' }}>
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                                        <DatePicker
                                                            margin="normal"
                                                            id="validFrom"
                                                            label="Tanggal"
                                                            format="dd MMM yyyy"
                                                            defaultValue="Pilih tanggal dan waktu"
                                                            value={data.appointment_date}
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change date',
                                                            }}
                                                            InputProps={{
                                                                style: {
                                                                    fontSize: 14,
                                                                },
                                                                disableUnderline: true
                                                            }}
                                                            InputLabelProps={{
                                                                style: {
                                                                    fontSize: 14,
                                                                    color: '#7e8085',
                                                                }
                                                            }}
                                                            inputProps={{
                                                                style: {
                                                                    color: 'black'
                                                                }
                                                            }}
                                                            style={{ width: '85%' }}
                                                            disabled={true}
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                </div>
                                                <div style={{ textAlign: 'left' }}>
                                                    <TextField
                                                        style={{ width: '85%' }}
                                                        id="jadwalPeriksa"
                                                        name="jadwalPeriksa"
                                                        label="Jadwal Periksa"
                                                        value={data.patient_schedule}
                                                        onChange={(e) => {
                                                            alert('a')
                                                            // handleOnChange(e)
                                                            // setErrorKodeDokter(false)
                                                            // setTextKodeDokter("")
                                                        }}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: '#7e8085',
                                                            }
                                                        }}
                                                        inputProps={{
                                                            style: {
                                                                color: 'black'
                                                            }
                                                        }}
                                                        disabled={true}
                                                    />
                                                    {/* <Autocomplete
                                                options={dummyList}
                                                getOptionLabel={(option) => option.name}
                                                style={{width: '85%'}}
                                                debug
                                                name='jadwalPeriksa'
                                                id="jadwalPeriksa"
                                                value={data.patient_schedule}
                                                onChange={(event, newInputValue) => {
                                                    // setPoliklinik(newInputValue)
                                                }}
                                                renderInput={(params) =>
                                                    <TextField
                                                        {...params}
                                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                                        label="Jadwal Periksa"
                                                    />
                                                }
                                            /> */}
                                                </div>
                                                <div className="">
                                                    <TextField
                                                        style={{ width: '85%', marginTop: 15 }}
                                                        id="reservasi"
                                                        name="reservasi"
                                                        label="Reservasi Via"
                                                        value={data.reservation_from || "-"}
                                                        onChange={(e) => {
                                                            // setTextAlamat("")
                                                            // setErrorAlamat(true)
                                                            // handleOnChange(e)
                                                        }}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: '#7e8085',
                                                            }
                                                        }}
                                                        disabled={true}
                                                        inputProps={{
                                                            style: {
                                                                color: 'black'
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="column-2">
                                                <div className="">
                                                    <TextField
                                                        style={{ width: '85%', cursor: 'default' }}
                                                        // onClick={() => setVisibleSetListPoli(true)}
                                                        name='Opsi Pembayaran'
                                                        id="payment"
                                                        label="Klinik"
                                                        defaultValue="Pilih Klinik"
                                                        value={`Poliklinik ${data.polyclinic.name}`}
                                                        // onChange={(event, newInputValue) => {
                                                        //     // setPoliklinik(newInputValue)
                                                        // }}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: '#7e8085',
                                                            }
                                                        }}
                                                        disabled={true}
                                                        inputProps={{
                                                            style: {
                                                                color: 'black'
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div className="">
                                                    <TextField
                                                        style={{ width: '85%', marginTop: 17 }}
                                                        id="namaDokter"
                                                        name="namaDokter"
                                                        label="Nama Dokter"
                                                        value={data.doctor.name}
                                                        onChange={(e) => {
                                                            // handleOnChange(e)
                                                            // setErrorKodeDokter(false)
                                                            // setTextKodeDokter("")
                                                        }}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: '#7e8085',
                                                            }
                                                        }}
                                                        disabled={true}
                                                        inputProps={{
                                                            style: {
                                                                color: 'black'
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div className="">
                                                    <TextField
                                                        style={{ width: '85%', marginTop: 17 }}
                                                        id="namaDokter"
                                                        name="namaDokter"
                                                        label="Lokasi Praktek Dokter"
                                                        defaultValue=" "
                                                        value={data.location}
                                                        onChange={(e) => {
                                                            // handleOnChange(e)
                                                            // setErrorKodeDokter(false)
                                                            // setTextKodeDokter("")
                                                        }}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: '#7e8085',
                                                            }
                                                        }}
                                                        disabled={true}
                                                        inputProps={{
                                                            style: {
                                                                color: 'black'
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                }

                            </div>
                            <div>
                                <Typography style={{ color: 'black', fontSize: 18, fontWeight: 550, textAlign: 'left' }}>Kelengkapan Data Pasien</Typography>
                                <div className="grid grid-2x grid-mobile-none" style={{ padding: '10px 20px 20px 20px', }}>
                                    <div className="column-1">
                                        <div style={{ textAlign: 'left' }}>
                                            <TextField
                                                style={{ width: '85%' }}
                                                id="idReservasi"
                                                name="idReservasi"
                                                label="ID Reservasi"
                                                value={data.booking_id}
                                                onChange={(e) => {
                                                    // handleOnChange(e)
                                                    // setErrorKodeDokter(false)
                                                    // setTextKodeDokter("")
                                                }}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: '#7e8085',
                                                    }
                                                }}
                                                disabled={true}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div style={{ textAlign: 'left' }}>
                                            <TextField
                                                style={{ width: '85%', marginTop: 15 }}
                                                id="queue"
                                                name="queue"
                                                label="No Antrian"
                                                value={data.queue_number}
                                                onChange={(e) => {
                                                    // handleOnChange(e)
                                                    // setErrorKodeDokter(true)
                                                    // setTextKodeDokter("")
                                                }}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: '#7e8085',
                                                    }
                                                }}
                                                disabled={true}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div style={{ textAlign: 'left' }}>
                                            <TextField
                                                style={{ width: '85%', marginTop: 15 }}
                                                id="noRekam"
                                                name="noRekam"
                                                label="No Rekam Medis"
                                                value={data.patient.medical_record_no || "-"}
                                                onChange={(e) => {
                                                    // setErrorNoSTR(true)
                                                    // setTextNoSTR("")
                                                    // handleOnChange(e)
                                                }}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: '#7e8085',
                                                    }
                                                }}
                                                disabled={true}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div style={{ textAlign: 'left' }}>
                                            <TextField
                                                style={{ width: '85%', marginTop: 15 }}
                                                id="jenisKelamin"
                                                name="jenisKelamin"
                                                label="Jenis Kelamin"
                                                value={data.patient.gender === 'L' ? "Laki-Laki" : "Perempuan"}
                                                onChange={(e) => {
                                                    // setErrorNoSTR(true)
                                                    // setTextNoSTR("")
                                                    // handleOnChange(e)
                                                }}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: '#7e8085',
                                                    }
                                                }}
                                                disabled={true}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div style={{ textAlign: 'left' }}>
                                            <TextField
                                                style={{ width: '85%', marginTop: 10 }}
                                                id="noHp"
                                                name="noHp"
                                                label="No. Handphone"
                                                value={data.patient.phone}
                                                // error={errorNoSTR}
                                                // helperText={textNoSTR}
                                                placeholder={"input No hp pasien"}
                                                onChange={(e) => {
                                                    // setErrorNoSTR(true)
                                                    // setTextNoSTR("")
                                                    // handleOnChange(e)
                                                }}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: '#7e8085',
                                                    }
                                                }}
                                                disabled={true}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="column-2">
                                        <div style={{ textAlign: 'left' }}>
                                            <TextField
                                                style={{ width: '85%' }}
                                                id="namaPasien"
                                                name="namaPasien"
                                                label="Nama Pasien"
                                                value={data.patient.name}
                                                onChange={(e) => {
                                                    // handleOnChange(e)
                                                    // setErrorKodeDokter(true)
                                                    // setTextKodeDokter("")
                                                }}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: '#7e8085',
                                                    }
                                                }}
                                                disabled={true}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div style={{ textAlign: 'left' }}>
                                            <TextField
                                                style={{ width: '85%', marginTop: 15 }}
                                                id="noKtp"
                                                name="noKtp"
                                                label="No KTP"
                                                value={data.patient.identity_no || "-"}
                                                onChange={(e) => {
                                                    // setErrorNama(true)
                                                    // setTextNama("")
                                                    // handleOnChange(e)
                                                }}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: '#7e8085',
                                                    }
                                                }}
                                                disabled={true}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                            />

                                            {/* <Autocomplete
                                        style={{width: '85%', marginTop: 20}}
                                        options={dummyList}
                                        getOptionLabel={(option) => option.name}
                                        debug
                                        name='jenisKelamin'
                                        id="jenisKelamin"
                                        defaultValue="pilih jenis kelamin"
                                        onChange={(event, newInputValue) => {
                                            // setPoliklinik(newInputValue)
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Jenis Kelamin"
                                            />
                                        }
                                    /> */}
                                        </div>
                                        <div style={{ textAlign: 'left' }}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                                <DatePicker
                                                    margin="normal"
                                                    id="bod"
                                                    label="Tanggal Lahir"
                                                    format="dd MMM yyyy"
                                                    defaultValue="Pilih tanggal lahir pasien"
                                                    value={new Date(data.patient.date_of_birth)}
                                                    // onChange={(date) => {
                                                    //     pertanyaanLength.tanggalBerlaku = new Date(date).toLocaleDateString()
                                                    // }}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                    InputProps={{
                                                        // startAdornment: <InputAdornment style={{  height: '10%', right: 0, position: 'absolute' }}><img src={search} style={{ height: '2vh' }} /></InputAdornment>,
                                                        disableUnderline: true
                                                    }}
                                                    disabled={true}
                                                    inputProps={{
                                                        style: {
                                                            color: 'black'
                                                        }
                                                    }}
                                                    style={{ width: '85%' }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                                        <div style={{ textAlign: 'left' }}>
                                            <TextField
                                                style={{ width: '85%', marginTop: 0 }}
                                                id="alamat"
                                                name="alamat"
                                                label="Alamat"
                                                value={data.patient.address || "-"}
                                                onChange={(e) => {
                                                    // setTextAlamat("")
                                                    // setErrorAlamat(true)
                                                    // handleOnChange(e)
                                                }}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: '#7e8085',
                                                    }
                                                }}
                                                disabled={true}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                            />
                                            <TextField
                                                style={{ width: '100%', marginTop: 10 }}
                                                id="inputKeluhan"
                                                name="inputKeluhan"
                                                label="Catatan Pasien"
                                                value={data.notes === "" || data.notes === null || data.notes === "null" ? "-" : data.notes}
                                                onChange={(e) => {
                                                    // setErrorNoSTR(true)
                                                    // setTextNoSTR("")
                                                    // handleOnChange(e)
                                                }}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: '#7e8085',
                                                    }
                                                }}
                                                disabled={true}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {data.appointment_status_name !== "Cancel" && (
                                    <div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography>File Pendukung</Typography>
                                        </div>
                                        <div className="grid grid-2x grid-mobile-none" style={{ padding: '10px 20px 20px' }}>
                                            <div className="column-1">
                                                <div style={{ textAlign: 'left' }}>
                                                    <Typography style={{ fontSize: 13, color: '#7e8085', fontWeight: 500 }}>Upload File Medical Check Up / LAB</Typography>
                                                    {data.patient.media.length > 0 ?
                                                        data.patient.media.map((item) => {
                                                            return (
                                                                <div
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        window.open(item.file_url, "_blank")
                                                                    }}>
                                                                    <Typography style={{ fontSize: 14, color: 'black' }}>{item.file_name}</Typography>
                                                                </div>
                                                            )
                                                        })
                                                        :
                                                        <Typography style={{ fontSize: 14, color: 'black' }}>-</Typography>
                                                    }
                                                </div>
                                                {paymentMethod && paymentMethod.id === 3 ?
                                                    <div style={{ textAlign: 'left', marginTop: 10 }}>
                                                        <TextField
                                                            style={{ width: '85%' }}
                                                            label="Nama Pasien BPJS"
                                                            placeholder={"Input Nama Pasien BPJS"}
                                                            inputProps={{
                                                                style: {
                                                                    fontSize: 14
                                                                },
                                                            }}
                                                            onChange={(e) => {
                                                                setNamaPasienBPJS(e.target.value)
                                                                forceUpdate()
                                                            }}
                                                            value={namaPasienBPJS}
                                                            InputLabelProps={{
                                                                style: {
                                                                    fontSize: 16,
                                                                    color: '#7e8085',
                                                                }
                                                            }}
                                                        />
                                                    </div> :
                                                    paymentMethod && paymentMethod.id === 2 ?

                                                        <div style={{ textAlign: 'left', marginTop: 10 }}>
                                                            <Autocomplete
                                                                style={{ width: '85%' }}
                                                                options={categoryProvider}
                                                                getOptionLabel={(option) => option.type}
                                                                debug
                                                                value={pickCategory}
                                                                onChange={(a, newInputValue) => {
                                                                    setLoading(true)
                                                                    setPickCategory(newInputValue)
                                                                    setProvider(null)
                                                                    getProviderByCategory(newInputValue && newInputValue.type)
                                                                }}
                                                                renderInput={(params) =>
                                                                    <TextField
                                                                        {...params}
                                                                        required={noKartuAsuransi !== "" ? true : false}
                                                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                                                        label="Kategori Provider"
                                                                    />
                                                                }
                                                            />
                                                            <Autocomplete
                                                                style={{ width: '85%', marginTop: 10 }}
                                                                options={listProvider}
                                                                disabled={pickCategory === null ? true : false}
                                                                getOptionLabel={(option) => option.name}
                                                                debug
                                                                value={provider}
                                                                onChange={(a, newInputValue) => {
                                                                    setProvider(newInputValue)
                                                                    setPickAsuransi(null)
                                                                }}
                                                                renderInput={(params) =>
                                                                    <TextField
                                                                        {...params}
                                                                        required={noKartuAsuransi !== null || noKartuAsuransi !== "" ? true : false}
                                                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                                                        label="Provider"
                                                                    />
                                                                }
                                                            />
                                                        </div>
                                                        : null
                                                }
                                            </div>
                                            <div className="column-2">
                                                {paymentMethod && paymentMethod.id === 3 ?
                                                    <div style={{ textAlign: 'left' }}>
                                                        <TextField
                                                            style={{ width: '85%', marginTop: -5 }}
                                                            label="No Rujukan"
                                                            placeholder={"Input No Rujukan"}
                                                            inputProps={{
                                                                style: {
                                                                    fontSize: 14
                                                                },
                                                            }}
                                                            value={noRujukan}
                                                            error={errorRujukan}
                                                            helperText={textErrorRujukan}
                                                            onChange={(e) => {
                                                                setNoRujukan(e.target.value)
                                                                setTextErrorRujukan("")
                                                                setErrorRujukan(false)
                                                                forceUpdate()
                                                            }}
                                                            InputLabelProps={{
                                                                style: {
                                                                    fontSize: 16,
                                                                    color: '#7e8085',
                                                                }
                                                            }}
                                                        />

                                                        <TextField
                                                            style={{ width: '85%', marginTop: 10 }}
                                                            label="No Kartu"
                                                            placeholder={"Input No Kartu BPJS"}
                                                            inputProps={{
                                                                style: {
                                                                    fontSize: 14
                                                                },
                                                            }}
                                                            onChange={(e) => {
                                                                setNoKartuBPJS(e.target.value)
                                                                forceUpdate()
                                                            }}
                                                            value={noKartuBPJS}
                                                            InputLabelProps={{
                                                                style: {
                                                                    fontSize: 16,
                                                                    color: '#7e8085',
                                                                }
                                                            }}
                                                        />
                                                    </div> :
                                                    paymentMethod && paymentMethod.id === 2 ?
                                                        <div style={{}}>
                                                            <TextField
                                                                style={{ width: '85%' }}
                                                                label="No Kartu Peserta Jaminan"
                                                                placeholder={"Input No Kartu Peserta Jaminan"}
                                                                required
                                                                inputProps={{
                                                                    style: {
                                                                        fontSize: 14
                                                                    },
                                                                }}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        fontSize: 16,
                                                                        color: '#7e8085',
                                                                    }
                                                                }}
                                                                onChange={(e) => {
                                                                    setNoKartuAsuransi(e.target.value)
                                                                    forceUpdate()
                                                                }}
                                                                value={noKartuAsuransi}
                                                                InputProps={{
                                                                    endAdornment:
                                                                        <InputAdornment position="end" style={{ marginRight: '5%' }}>
                                                                            {data.patient.medical_record_no && (
                                                                                <div style={{ cursor: 'pointer' }}
                                                                                    onClick={() => {
                                                                                        getListAsuransi(data.patient.medical_record_no, paymentMethod && paymentMethod.id === 2 ? "" : "&without_insurance=1")
                                                                                    }}
                                                                                >
                                                                                    <img src={ic_search} />
                                                                                </div>
                                                                            )}
                                                                        </InputAdornment>,
                                                                }}
                                                            />
                                                            <TextField
                                                                style={{ width: '85%', marginTop: 5 }}
                                                                label="Nama Pemegang Kartu Asuransi"
                                                                placeholder={"Input Nama Pemegang Kartu"}
                                                                required
                                                                inputProps={{
                                                                    style: {
                                                                        fontSize: 14
                                                                    },
                                                                }}
                                                                onChange={(e) => {
                                                                    setNamaPasienAsuransi(e.target.value)
                                                                    forceUpdate()
                                                                }}
                                                                value={namaPasienAsuransi}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        fontSize: 16,
                                                                        color: '#7e8085',
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                        : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="grid grid-2x grid-mobile-none" style={{ padding: '10px 20px 20px 20px', }}>
                                    {
                                        data.appointment_status_name === "Cancel" ?
                                            <TextField
                                                label="Alasan Batal"
                                                style={{ width: '100%' }}
                                                value={alasanBatal}
                                                // disabled={true}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    setAlasanBatal(e.target.value);
                                                    forceUpdate()
                                                }}
                                                InputProps={{
                                                    disableUnderline: false
                                                }}
                                            />
                                            : null
                                    }
                                </div>
                            </div>
                            {
                                data.appointment_status_name !== "Cancel" ?
                                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <div onClick={() => setVisibleEdit(false)} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                        </div>
                                        <div
                                            onClick={() => disableButton === true ? null : detailDokter && detailDokter.is_leave ? null : doEdit()}
                                            style={{ height: 32, width: 150, backgroundColor: disableButton ? 'grey' : detailDokter && detailDokter.is_leave ? 'grey' : '#2a9c6c', borderRadius: 20, cursor: 'pointer' }} >
                                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5, textAlign: 'center' }}>Simpan</Typography>
                                        </div>
                                    </div>
                                    :
                                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <div onClick={() => setVisibleEdit(false)} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                        </div>
                                        <div
                                            onClick={() => disableButton === true ? null : detailDokter && detailDokter.is_leave ? null : changeStatus()}
                                            style={{ height: 32, width: 150, backgroundColor: disableButton ? 'grey' : detailDokter && detailDokter.is_leave ? 'grey' : '#2a9c6c', borderRadius: 20, cursor: 'pointer' }} >
                                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5, textAlign: 'center' }}>Simpan</Typography>
                                        </div>
                                    </div>

                            }
                        </div> :
                        <div style={{ height: '89vh', overflow: 'auto', fontFamily: 'Poppins' }}>
                            <div style={{ marginTop: 20 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 20px 20px' }}>
                                    <Typography style={{ fontWeight: '500', fontSize: 20 }}>Data Reservasi</Typography>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        {data.payment_option_id === 3 && data.appointment_status_id === 3 && <div
                                            onClick={()=>{
                                                getPrintSEP()
                                            }}
                                                style={{ height: 34, backgroundColor: '#65ae92', borderRadius: 20, cursor: 'pointer', marginTop: 0, marginRight: 10, padding: '0 10px' }}
                                            >
                                                <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: 7, cursor: 'pointer' }}>
                                                    <img src={print} style={{ width: 18, height: 18, marginRight: 10 }} />
                                                    <Typography style={{ color: '#ffffff', textAlign: 'center', fontSize: 16, marginTop: -2, marginRight: 4 }}>Print SEP</Typography>
                                                </div>
                                        </div>}
                                        <div>
                                            <ReactToPrint
                                                pageStyle={pageStyle}
                                                trigger={() => {
                                                    return (
                                                        <div
                                                            style={{ height: 34, width: 83, backgroundColor: '#65ae92', borderRadius: 20, cursor: 'pointer', margin: 'auto' }}
                                                        // style={{ cursor: 'pointer', height: '4vh', width: '25vh', backgroundColor: '#34b68b', borderRadius: '10vh', borderColor: '#34b68b', borderWidth: '.4vh', borderStyle: 'solid', alignItems: 'center', justifyContent: 'center', display: 'flex' }}
                                                        >
                                                            <div style={{ display: 'flex', justifyContent: 'space-evenly', cursor: 'pointer', height: 'inherit', alignItems: 'center' }}>
                                                                <img src={print} style={{ width: 18, height: 18 }} />
                                                                <Typography style={{ color: '#ffffff', textAlign: 'center', fontSize: 16, marginTop: -2, marginRight: 4 }}>Print</Typography>
                                                            </div>
                                                        </div>
                                                    )
                                                }}
                                                content={() => componentRef.current}
                                            >
                                            </ReactToPrint>
                                            <div style={{ display: 'none' }}>
                                                <ComponentToPrint
                                                    namaDokter={tempData.doctor.name}
                                                    desc={tempData.doctor.speciality}
                                                    namaPoli={tempData.polyclinic.name}
                                                    noRekam={tempData.patient.medical_record_no}
                                                    namaPasien={tempData.patient.name}
                                                    dateTime={displayDate}
                                                    pembayaran={tempData.payment_option_name}
                                                    dokterRoom={room}
                                                    noAntrian={tempData.queue_number}
                                                    qrCodeURL={tempData.booking_id}
                                                    bookingID={tempData.booking_id}
                                                    sep_no={data.sep_no}
                                                    noRegistrasi={data.registration_no_client}
                                                    isBpjs={
                                                        data.payment_option_id === 3 ? true : false //3 = BPJS
                                                    }
                                                    isCheckin={
                                                        data.appointment_status.checkin.date_time !== null ? true : false
                                                    }
                                                    ref={componentRef}
                                                />
                                            </div>
                                        </div>
                                        {buttonEdit && (
                                            <div style={{ backgroundColor: '#65ae92', color: 'white', width: 83, height: 34, borderRadius: 30, marginLeft: 20 }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: 2, cursor: 'pointer' }}
                                                    onClick={() => {
                                                        setVisibleEdit(true)
                                                        getProviderByCode()
                                                        handlePaymentOption()
                                                    }}
                                                >
                                                    <img src={ic_edit} style={{ width: 30, height: 32 }} />
                                                    <Typography style={{ textAlign: 'center', fontSize: 16, marginTop: 3, marginRight: 5 }}>Edit</Typography>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="grid grid-2x grid-mobile-none" style={{ padding: '0px 20px 20px 20px', }}>
                                    <div className="column-1">
                                        <div className="">
                                            <TextField
                                                style={{ width: '85%', borderBottom: 'none !important' }}
                                                id="opsiPembayaran"
                                                name="opsiPembayaran"
                                                label="Opsi Pembayaran"
                                                value={data.payment_option_name}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                disabled={true}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className="">
                                            <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                                <DatePicker
                                                    margin="normal"
                                                    id="validFrom"
                                                    label="Tanggal & Waktu"
                                                    format="dd MMM yyyy"
                                                    defaultValue="Pilih tanggal dan waktu"
                                                    value={data.appointment_date}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 18,
                                                            color: '#7e8085',
                                                            fontWeight: 500
                                                        }
                                                    }}
                                                    inputProps={{
                                                        style: {
                                                            color: 'black'
                                                        }
                                                    }}
                                                    style={{ width: '85%' }}
                                                    disabled={true}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                                        <div className="">
                                            <TextField
                                                style={{ width: '85%' }}
                                                id="jadwalPeriksa"
                                                name="jadwalPeriksa"
                                                label="Jadwal Periksa"
                                                value={data.patient_schedule}
                                                onChange={(e) => {
                                                    alert('a')
                                                    // handleOnChange(e)
                                                    // setErrorKodeDokter(false)
                                                    // setTextKodeDokter("")
                                                }}
                                                disabled={true}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className="">
                                            <TextField
                                                style={{ width: '85%', marginTop: 10 }}
                                                id="reservasiVia"
                                                name="reservasiVia"
                                                label="Reservasi Via"
                                                value={data.reservation_from}
                                                onChange={(e) => {
                                                    alert('a')
                                                    // handleOnChange(e)
                                                    // setErrorKodeDokter(false)
                                                    // setTextKodeDokter("")
                                                }}
                                                disabled={true}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="column-2">
                                        <div className="">
                                            <TextField
                                                style={{ width: '85%', cursor: 'default' }}
                                                // onClick={() => setVisibleSetListPoli(true)} 
                                                id="payment"
                                                label="Klinik"
                                                defaultValue="Pilih Poliklinik"
                                                value={`Poliklinik ${data.polyclinic.name}`}
                                                disabled={true}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className="">
                                            <TextField
                                                style={{ width: '85%', marginTop: 17 }}
                                                id="namaDokter"
                                                name="namaDokter"
                                                label="Nama Dokter"
                                                value={data.doctor.name}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="">
                                            <TextField
                                                style={{ width: '85%', marginTop: 17 }}
                                                id="namaDokter"
                                                name="namaDokter"
                                                label="Lokasi Praktek Dokter"
                                                defaultValue=" "
                                                value={data.location}
                                                onChange={(e) => {
                                                    // handleOnChange(e)
                                                    // setErrorKodeDokter(false)
                                                    // setTextKodeDokter("")
                                                }}
                                                disabled={true}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <Typography style={{ fontWeight: '500', fontSize: 20, textAlign: 'left', margin: '0 20px 20px' }}>Kelengakapan Data Pasien</Typography>
                                <div className="grid grid-2x grid-mobile-none" style={{ padding: '10px 20px 20px 20px', }}>
                                    <div className="column-1">
                                        <div className="">
                                            <TextField
                                                style={{ width: '85%' }}
                                                id="idReservasi"
                                                name="idReservasi"
                                                label="ID Reservasi"
                                                value={data.booking_id}
                                                onChange={(e) => {
                                                    // handleOnChange(e)
                                                    // setErrorKodeDokter(false)
                                                    // setTextKodeDokter("")
                                                }}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="">
                                            <TextField
                                                style={{ width: '85%', marginTop: 10 }}
                                                id="queue"
                                                name="queue"
                                                label="No Antrian"
                                                value={data.queue_number}
                                                onChange={(e) => {
                                                    // handleOnChange(e)
                                                    // setErrorKodeDokter(false)
                                                    // setTextKodeDokter("")
                                                }}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="">
                                            <TextField
                                                style={{ width: '85%', marginTop: 10 }}
                                                id="noRekam"
                                                name="noRekam"
                                                label="No Rekam Medis"
                                                value={data.patient.medical_record_no || "-"}
                                                onChange={(e) => {
                                                    // setErrorNoSTR(false)
                                                    // setTextNoSTR("")
                                                    // handleOnChange(e)
                                                }}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="">
                                            <TextField
                                                style={{ width: '85%', marginTop: 10 }}
                                                id="jenisKelamin"
                                                name="jenisKelamin"
                                                label="Jenis Kelamin"
                                                value={data.patient.gender === 'L' ? "Laki-Laki" : "Perempuan"}
                                                onChange={(e) => {
                                                    // setErrorNoSTR(false)
                                                    // setTextNoSTR("")
                                                    // handleOnChange(e)
                                                }}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="">
                                            <TextField
                                                style={{ width: '85%', marginTop: 10 }}
                                                id="noHp"
                                                name="noHp"
                                                label="No. Handphone"
                                                value={data.patient.phone}
                                                placeholder={"input No hp pasien"}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                                disabled={true}
                                            />
                                        </div>
                                        <TextField
                                            style={{ width: '85%', marginTop: 10 }}
                                            id="inputKeluhan"
                                            name="inputKeluhan"
                                            label="Catatan Pasien"
                                            value={data.notes === "" || data.notes === null || data.notes === "null" ? "-" : data.notes}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                },
                                                disableUnderline: true
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 18,
                                                    color: '#7e8085',
                                                    fontWeight: 500
                                                }
                                            }}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                            disabled={true}
                                        />
                                        {data.payment_option_id === 3 && (

                                            <div>
                                                <div style={{ marginTop: 10 }}>
                                                    <TextField
                                                        disabled
                                                        style={{ width: '85%' }}
                                                        label="Nama Pasien BPJS"
                                                        placeholder={"Input Nama Pasien BPJS"}
                                                        inputProps={{
                                                            style: {
                                                                fontSize: 14
                                                            },
                                                        }}
                                                        value={data.patient.bpjs_name === null || data.patient.bpjs_name === "" ? '-' : data.patient.bpjs_name}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: 'black'
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 18,
                                                                color: '#7e8085',
                                                                fontWeight: 500
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div style={{ marginTop: 10 }}>
                                                    <TextField
                                                        disabled
                                                        style={{ width: '85%' }}
                                                        label="Tanggal Rujukan"
                                                        inputProps={{
                                                            style: {
                                                                fontSize: 14
                                                            },
                                                        }}
                                                        value={data.reference_date === null ? '-' : data.reference_date}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: 'black'
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 18,
                                                                color: '#7e8085',
                                                                fontWeight: 500
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div style={{ marginTop: 10 }}>
                                                    <TextField
                                                        disabled
                                                        style={{ width: '85%' }}
                                                        label="Nomor SEP"
                                                        inputProps={{
                                                            style: {
                                                                fontSize: 14
                                                            },
                                                        }}
                                                        value={data.sep_no === null ? '-' : data.sep_no}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: 'black'
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 18,
                                                                color: '#7e8085',
                                                                fontWeight: 500
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                        )}
                                        {data.payment_option_id === 2 && (

                                            <div>
                                                <TextField
                                                    disabled
                                                    style={{ width: '85%' }}
                                                    label="Kategori Jaminan"
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: 'black'
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 18,
                                                            color: '#7e8085',
                                                            fontWeight: 500
                                                        }
                                                    }}
                                                    value={categoryDetail}
                                                />
                                                <div style={{ marginTop: 10 }}>
                                                    <TextField
                                                        disabled
                                                        style={{ width: '85%' }}
                                                        label="No Kartu Peserta Jaminan"
                                                        placeholder={"Input No Kartu Peserta Jaminan"}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: 'black'
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 18,
                                                                color: '#7e8085',
                                                                fontWeight: 500
                                                            }
                                                        }}
                                                        value={data.patient.insurance_no === null ? '-' : data.patient.insurance_no}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="column-2">
                                        <div className="">
                                            <TextField
                                                style={{ width: '85%' }}
                                                id="namaPasien"
                                                name="namaPasien"
                                                label="Nama Pasien"
                                                value={data.patient.name}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="">
                                            <TextField
                                                style={{ width: '85%', marginTop: 10 }}
                                                id="noKtp"
                                                name="noKtp"
                                                label="No KTP"
                                                value={data.patient.identity_no || "-"}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="">
                                            <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                                <DatePicker
                                                    margin="normal"
                                                    id="bod"
                                                    label="Tanggal Lahir"
                                                    format="dd MMM yyyy"
                                                    defaultValue="Pilih tanggal lahir pasien"
                                                    value={new Date(data.patient.date_of_birth)}
                                                    // onChange={(date) => {
                                                    //     pertanyaanLength.tanggalBerlaku = new Date(date).toLocaleDateString()
                                                    // }}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 18,
                                                            color: '#7e8085',
                                                            fontWeight: 500
                                                        }
                                                    }}
                                                    inputProps={{
                                                        style: {
                                                            color: 'black'
                                                        }
                                                    }}
                                                    disabled={true}
                                                    style={{ width: '85%' }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                                        <div className="">
                                            <TextField
                                                style={{ width: '85%', marginTop: 7 }}
                                                id="alamat"
                                                name="alamat"
                                                label="Alamat"
                                                value={data.patient.address || "-"}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="">
                                            <TextField
                                                style={{ width: '85%', marginTop: 5, cursor: 'default' }}
                                                id="kodeDokter"
                                                onClick={() => null}
                                                name="kodeDokter"
                                                label="Upload File Medical Check Up / LAB"
                                                defaultValue="-, -"
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                                disabled={true}
                                            />
                                        </div>
                                        {data.payment_option_id === 3 ?
                                            <div style={{ textAlign: 'left', marginLeft: 45 }}>
                                                <TextField
                                                    disabled
                                                    style={{ width: '85%', marginTop: 5 }}
                                                    label="No Rujukan"
                                                    placeholder={"Input No Rujukan"}
                                                    value={data.reference_no}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: 'black'
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 18,
                                                            color: '#7e8085',
                                                            fontWeight: 500
                                                        }
                                                    }}
                                                />

                                                <TextField
                                                    style={{ width: '85%', marginTop: 10 }}
                                                    disabled
                                                    label="No Kartu"
                                                    placeholder={"Input No Kartu BPJS"}
                                                    value={data.patient.bpjs_no === null || data.patient.bpjs_no === "" ? '-' : data.patient.bpjs_no}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: 'black'
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 18,
                                                            color: '#7e8085',
                                                            fontWeight: 500
                                                        }
                                                    }}
                                                />

                                                <div 
                                                    onClick={() => generatedSEP === 0 && data.sep_no != null ? postUpdateSEP() : null}
                                                    style={{
                                                        backgroundColor:generatedSEP === 0 && data.sep_no != null ? '#2a9c6c' : 'grey' ,
                                                        color:'white',
                                                        paddingTop: 5,paddingBottom: 5,
                                                        paddingLeft: 20, paddingRight: 20,
                                                        marginTop: 25,
                                                        display:'inline-block',
                                                        textDecoration:'none',
                                                        textAlign:'center',
                                                        borderRadius:20,
                                                        fontSize: 15,
                                                        cursor: 'pointer'
                                                    }}>
                                                    <Typography>Update SEP</Typography>
                                                </div>
                                            </div> :
                                            data.payment_option_id === 2 ?
                                                <div style={{}}>
                                                    <TextField
                                                        disabled
                                                        style={{ width: '85%' }}
                                                        label="Provider"
                                                        value={data.patient.insurance_name === null ? '-' : data.patient.insurance_name}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: 'black'
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 18,
                                                                color: '#7e8085',
                                                                fontWeight: 500
                                                            }
                                                        }}
                                                    />
                                                    <TextField
                                                        disabled
                                                        style={{ width: '85%', marginTop: 10 }}
                                                        label="Nama Tertera Dikartu Jaminan"
                                                        placeholder={"Input Nama Tertera Dikartu Jaminan"}
                                                        required
                                                        value={data.patient.card_name === null ? "-" : data.patient.card_name}
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                                color: 'black'
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 18,
                                                                color: '#7e8085',
                                                                fontWeight: 500
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                : null
                                        }
                                    </div>
                                </div>
                            </div>
                            <div>
                                <Typography style={{ fontWeight: '500', fontSize: 20, textAlign: 'left', margin: '0 20px 20px' }}>Status</Typography>
                                <div className="grid grid-2x" style={{ padding: '10px 20px 20px 20px', }}>
                                    <div className="column1">
                                        <div style={{ width: '100%' }}>
                                            <TextField
                                                label="Created Date"
                                                value={
                                                    data.appointment_status.book.date_time === null ? "-" : format(new Date(String(data.appointment_status.book.date_time)), 'dd MMM yyyy HH:mm')
                                                }
                                                style={{ width: '85%' }}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="">
                                            <TextField
                                                style={{ width: '85%', marginTop: 10 }}
                                                label="Status Emergency/Darurat"
                                                value={data.is_emergency === 1 ? `${data.queue_number}` : "-"}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="">
                                            {
                                                data.appointment_status_name === "Cancel" ?
                                                    <TextField
                                                        label="Alasan Batal"
                                                        style={{ width: '85%' }}
                                                        value={data.reasons || '-'}
                                                        multiline
                                                        InputProps={{
                                                            style: {
                                                                fontSize: 14,
                                                            },
                                                            disableUnderline: true
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: 18,
                                                                color: '#7e8085',
                                                                fontWeight: 500
                                                            }
                                                        }}
                                                        inputProps={{
                                                            style: {
                                                                color: 'black'
                                                            }
                                                        }}
                                                        disabled={true}
                                                    />
                                                    : null
                                            }
                                        </div>
                                        {data.appointment_status_name !== "Book" && (
                                            <div style={{ marginTop: 10, width: '100%' }}>
                                                <TextField
                                                    label="Updated Date"
                                                    value={
                                                        data.appointment_status_name === "Done" ? data.appointment_status.done.date_time === null ? "-" : format(new Date(String(data.appointment_status.done.date_time)), 'dd MMM yyyy HH:mm') :
                                                            data.appointment_status_name === "Cancel" ? data.appointment_status.cancel.date_time === null ? "-" : format(new Date(String(data.appointment_status.cancel.date_time)), 'dd MMM yyyy HH:mm') :
                                                                data.appointment_status_name === "Hold" ? data.appointment_status.hold.date_time === null ? "-" : format(new Date(String(data.appointment_status.hold.date_time)), 'dd MMM yyyy HH:mm') :
                                                                    data.appointment_status_name === "Check-In" ? data.appointment_status.checkin.date_time === null ? "-" : format(new Date(String(data.appointment_status.checkin.date_time)), 'dd MMM yyyy HH:mm') :
                                                                        data.appointment_status_name === "Reschedule" ? data.appointment_status.reschedule.date_time === null ? "-" : format(new Date(String(data.appointment_status.reschedule.date_time)), 'dd MMM yyyy HH:mm') : "-"

                                                    }
                                                    style={{ width: '85%' }}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 18,
                                                            color: '#7e8085',
                                                            fontWeight: 500
                                                        }
                                                    }}
                                                    inputProps={{
                                                        style: {
                                                            color: 'black'
                                                        }
                                                    }}
                                                    disabled={true}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className="column2">
                                        <div style={{ width: '100%' }}>
                                            <TextField
                                                label="Created By"
                                                value={
                                                    data.appointment_status.book.user_name == null ? "-" : data.appointment_status.book.user_name
                                                }
                                                style={{ width: '85%' }}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                                disabled={true}
                                            />
                                        </div>
                                        <div style={{ width: '100%', marginTop: 10 }}>
                                            <TextField
                                                label="Status Reservasi"
                                                value={data.appointment_status_name}
                                                style={{ width: '85%' }}
                                                InputProps={{
                                                    style: {
                                                        fontSize: 14,
                                                    },
                                                    disableUnderline: true
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 18,
                                                        color: '#7e8085',
                                                        fontWeight: 500
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        color: 'black'
                                                    }
                                                }}
                                                disabled={true}
                                            />
                                        </div>
                                        {data.appointment_status_name === "Cancel" && (
                                            <div style={{ width: '100%', marginTop: 10 }}>
                                                <TextField
                                                    label=""
                                                    value={""}
                                                    style={{ width: '85%' }}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 18,
                                                            color: '#7e8085',
                                                            fontWeight: 500
                                                        }
                                                    }}
                                                    inputProps={{
                                                        style: {
                                                            color: 'black'
                                                        }
                                                    }}
                                                    disabled={true}
                                                />
                                            </div>
                                        )}
                                        {data.appointment_status_name !== "Book" && (
                                            <div style={{ marginTop: 10, width: '100%' }}>
                                                <TextField
                                                    label="Updated By"
                                                    value={
                                                        data.appointment_status_name === "Done" ? data.appointment_status.done.user_name == null ? "-" : data.appointment_status.done.user_name :
                                                            data.appointment_status_name === "Cancel" ? data.appointment_status.cancel.user_name == null ? "-" : data.appointment_status.cancel.user_name :
                                                                data.appointment_status_name === "Hold" ? data.appointment_status.hold.user_name == null ? "-" : data.appointment_status.hold.user_name :
                                                                    data.appointment_status_name === "Check-In" ? data.appointment_status.checkin.user_name == null ? "-" : data.appointment_status.checkin.user_name :
                                                                        data.appointment_status_name === "Reschedule" ? data.appointment_status.reschedule.user_name == null ? "-" : data.appointment_status.reschedule.user_name : "-"
                                                    }
                                                    style={{ width: '85%' }}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                        },
                                                        disableUnderline: true
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 18,
                                                            color: '#7e8085',
                                                            fontWeight: 500
                                                        }
                                                    }}
                                                    inputProps={{
                                                        style: {
                                                            color: 'black'
                                                        }
                                                    }}
                                                    disabled={true}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div style={{}}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', width: '85%' }}>
                                    <Typography style={{ fontWeight: '500', fontSize: 20, textAlign: 'left', margin: '0 20px 20px' }}>Catatan Follow Up Petugas</Typography>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '28%' }}>
                                        <div style={{ alignSelf: 'center' }}
                                            onClick={() => {
                                                if (expand === false) {
                                                    setExpand(true)
                                                } else {
                                                    setExpand(false)
                                                }
                                            }}
                                        >
                                            {/* <Typography style={{textAlignLast: 'center', cursor: 'pointer', textDecoration: 'underline'}}>{expand === false ? "Expand" : "Collapse"}</Typography> */}
                                        </div>
                                    </div>
                                </div>
                                {
                                    data.appointment_notes != false && expand === true ?
                                        data.appointment_notes.map((el, idx) => {
                                            console.log(el);
                                            let tanggal = new Date(el.created_at).getDate() < 10 ? `0${new Date(el.created_at).getDate()}` : new Date(el.created_at).getDate()
                                            let bulan = new Date(el.created_at).getMonth()
                                            let tahun = new Date(el.created_at).getFullYear()
                                            let jam = new Date(el.created_at).getHours() < 10 ? `0${new Date(el.created_at).getHours()}` : new Date(el.created_at).getHours()
                                            let menit = new Date(el.created_at).getMinutes() < 10 ? `0${new Date(el.created_at).getMinutes()}` : new Date(el.created_at).getMinutes()
                                            switch (bulan) {
                                                case 0:
                                                    bulan = "Jan"
                                                    break;
                                                case 1:
                                                    bulan = "Fab"
                                                    break;
                                                case 2:
                                                    bulan = "Mar"
                                                    break;
                                                case 3:
                                                    bulan = "Apr"
                                                    break;
                                                case 4:
                                                    bulan = "Mei"
                                                    break;
                                                case 5:
                                                    bulan = "Jun"
                                                    break;
                                                case 6:
                                                    bulan = "Jul"
                                                    break;
                                                case 7:
                                                    bulan = "Agus"
                                                    break;
                                                case 8:
                                                    bulan = "Sep"
                                                    break;
                                                case 9:
                                                    bulan = "Oct"
                                                    break;
                                                case 10:
                                                    bulan = "Nov"
                                                    break;
                                                default:
                                                    bulan = "Dese"
                                                    break;
                                            }
                                            return (
                                                <div>
                                                    <div className="grid grid-2x" style={{ padding: 20, paddingRight: 50, paddingLeft: 50, display: 'flex', justifyContent: 'space-between', width: '85%' }}>
                                                        <div className="column1">
                                                            <Typography style={{ color: '#a4a4a4', fontSize: 18, fontWeight: 500 }}>{el.created_by}</Typography>
                                                        </div>
                                                        <div className="column2">
                                                            <Typography style={{ color: '#a4a4a4', fontSize: 13, fontWeight: 400, justifyContent: 'flex-end', display: 'flex' }}>{`${tanggal} ${bulan} ${tahun} ${jam}:${menit}`}</Typography>
                                                        </div>
                                                    </div>
                                                    <div className="grid grid-2x" style={{ padding: 20, paddingRight: 50, paddingLeft: 50, marginTop: -30 }}>
                                                    </div>
                                                    <div className="grid grid-2x" style={{ padding: 20, paddingRight: 50, paddingLeft: 50, marginTop: -30 }}>
                                                        <Typography style={{ width: '150%', fontSize: 14 }}>{el.notes}</Typography>
                                                    </div>
                                                    <div className="grid grid-2x" style={{ padding: 20, paddingRight: 50, paddingLeft: 50, marginTop: -30 }}>
                                                        <img src={line} style={{ width: '167%' }} />
                                                    </div>
                                                </div>
                                            )
                                        })
                                        : data.appointment_notes != false && data.appointment_notes.length >= 0 ?
                                            <div>
                                                <div className="grid grid-2x" style={{ padding: 20, paddingRight: 50, paddingLeft: 50, display: 'flex', justifyContent: 'space-between', width: '85%' }}>
                                                    <div className="column1">
                                                        <Typography style={{ color: '#a4a4a4', fontSize: 18, fontWeight: 500 }}>{data.appointment_notes[0].created_by}</Typography>
                                                    </div>
                                                    <div className="column2">
                                                        <Typography style={{ color: '#a4a4a4', fontSize: 13, fontWeight: 400, display: 'flex', justifyContent: 'flex-end' }}>
                                                            {
                                                                `${new Date(data.appointment_notes[0].created_at).getDate() < 10 ? `0${new Date(data.appointment_notes[0].created_at).getDate()}` : new Date(data.appointment_notes[0].created_at).getDate()}
                                            ${new Date(data.appointment_notes[0].created_at).getMonth() === 0 ? "Jan" : new Date(data.appointment_notes[0].created_at).getMonth() === 1 ? "Feb" : new Date(data.appointment_notes[0].created_at).getMonth() === 2 ? "Mar" : new Date(data.appointment_notes[0].created_at).getMonth() === 3 ? "Apr" : new Date(data.appointment_notes[0].created_at).getMonth() === 4 ? "Mei" : new Date(data.appointment_notes[0].created_at).getMonth() === 5 ? "Jun" : new Date(data.appointment_notes[0].created_at).getMonth() === 6 ? "Jul" : new Date(data.appointment_notes[0].created_at).getMonth() === 7 ? "Aug" : new Date(data.appointment_notes[0].created_at).getMonth() === 8 ? "Sep" : new Date(data.appointment_notes[0].created_at).getMonth() === 9 ? "Oct" : new Date(data.appointment_notes[0].created_at).getMonth() === 10 ? "Nov" : new Date(data.appointment_notes[0].created_at).getMonth() === 11 ? "Des" : null}
                                            ${new Date(data.appointment_notes[0].created_at).getFullYear()}
                                            ${new Date(data.appointment_notes[0].created_at).getHours() < 10 ? `0${new Date(data.appointment_notes[0].created_at).getHours()}` : new Date(data.appointment_notes[0].created_at).getHours()}:${new Date(data.appointment_notes[0].created_at).getMinutes() < 10 ? `0${new Date(data.appointment_notes[0].created_at).getMinutes()}` : new Date(data.appointment_notes[0].created_at).getMinutes()}
                                            `
                                                            }
                                                        </Typography>
                                                    </div>
                                                </div>
                                                <div className="grid grid-2x" style={{ padding: 20, paddingRight: 50, paddingLeft: 50, marginTop: -30 }}>
                                                </div>
                                                <div className="grid grid-2x" style={{ padding: 20, paddingRight: 50, paddingLeft: 50, marginTop: -30 }}>
                                                    <Typography style={{ width: '150%', fontSize: 14 }}>{data.appointment_notes[0].notes}</Typography>
                                                </div>
                                                <div className="grid grid-2x" style={{ padding: 20, paddingRight: 50, paddingLeft: 50, marginTop: -30 }}>
                                                    <img src={line} style={{ width: '167%' }} />
                                                </div>
                                            </div>
                                            : null
                                }
                                {
                                    data.appointment_notes.length != false && data.appointment_notes.length > 1 && expand === false ?
                                        <Typography onClick={() => setExpand(true)} style={{ cursor: 'pointer', color: '#278863', textAlign: 'center', fontSize: 15, fontWeight: 500 }}>Lihat Semua Catatan</Typography>
                                        : data.appointment_notes.length != false && data.appointment_notes.length > 1 && expand === true ?
                                            <Typography onClick={() => setExpand(false)} style={{ cursor: 'pointer', color: '#278863', textAlign: 'center', fontSize: 15, fontWeight: 500 }}>Lihat Lebih Sedikit</Typography>
                                            : null
                                }
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'space-between', margin: 'auto', alignItems: 'center', marginTop: 0, width: '97%' }}>
                                {
                                    data.appointment_status_name === "Cancel" ?
                                        <div></div> :
                                        data.appointment_status_name === "Hold" ?
                                            <div>
                                            </div>
                                            :
                                            <div></div>
                                }
                                <div
                                    onClick={() => history.goBack()}
                                    style={{ height: 32, width: 120, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', alignItems: 'center', justifyItems: 'center', marginBottom: 20 }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5, textAlignLast: 'center' }}>Kembali</Typography>
                                </div>
                            </div>
                        </div>
                }
                <div>
                </div>

                {
                    uploadVisible && (
                        <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                            <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                        <div className="popup-title">
                                            <span style={{ color: 'black', fontSize: 18 }}>Upload File</span>
                                        </div>
                                    </div>
                                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                        <button
                                            type="button"
                                            className="btn btn-circle btn-white"
                                            onClick={() => {
                                                setUploadVisible(false)
                                                setPicture("")
                                            }}
                                        >
                                            <img src={CloseImage} />
                                        </button>
                                    </div>
                                </div>
                                <ImageUploader
                                    withIcon={true}
                                    withPreview
                                    buttonStyles={pictures.length > 0 ? { display: 'none' } : null}
                                    buttonText={'Select Picture'}
                                    onChange={onDrop}
                                    imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                                    maxFileSize={1000000}
                                    label={"Max file size: 1 Mb, accepted: jpg or png"}
                                />
                                {pictures.length > 0 ?
                                    <div style={{ display: 'grid', margin: 20 }}>
                                        <div style={{ justifySelf: 'center' }}>
                                            <span style={{ color: '#fff', padding: 20, paddingBottom: 10, paddingTop: 10, borderRadius: 15, cursor: 'pointer', backgroundColor: '#2a9c6c' }} onClick={() => uploadFoto()}>Upload</span>
                                        </div>
                                    </div> : null
                                }
                            </div>
                        </div>
                    )
                }

                {
                    status ?
                        <div className="App app-popup-show">
                            <div style={{ width: '100%', height: '60vh', margin: 'auto', position: 'relative' }}>
                                <img src={bg_notif} style={{ width: '30%', height: '70vh', margin: 'auto' }}></img>
                                <div style={{}}>
                                    <img src={circle} style={{ width: 104, height: 104, top: 20, position: 'absolute', margin: 'auto', right: '46%' }} />
                                    <img src={ic_checkmark} style={{ width: 41, height: 41, position: 'absolute', top: 50, right: '48.2%' }} />
                                </div>
                                <Typography style={{ top: 130, position: 'absolute', left: '42%', fontSize: 30, color: '#278863' }} >Reservasi Berhasil</Typography>
                            </div>
                            <div style={{ height: '38vh', width: '27vw', position: 'absolute', top: '50%', left: '37%' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div style={{ color: '#bdc3c7', fontSize: 16, fontFamily: 'poppins' }}>
                                        <Typography style={{ textAlign: 'start' }} >Kode Reservasi</Typography>
                                        <Typography style={{ textAlign: 'start', marginTop: 10 }} >Poliklinik</Typography>
                                        <Typography style={{ textAlign: 'start', marginTop: 10 }} >Dokter</Typography>
                                        <Typography style={{ textAlign: 'start', marginTop: 10 }} >Nama Pasien</Typography>
                                        <Typography style={{ textAlign: 'start', marginTop: 10 }} >Hari & Waktu</Typography>
                                        <Typography style={{ textAlign: 'start', marginTop: 10 }} >Catatan Pasien</Typography>
                                    </div>
                                    <div style={{ marginRight: 55 }}>
                                        <Typography style={{ textAlign: 'start' }} >IDB123</Typography>
                                        <Typography style={{ textAlign: 'start', marginTop: 10 }} >THT</Typography>
                                        <Typography style={{ textAlign: 'start', marginTop: 10 }} >Dr. Albert Leonardo</Typography>
                                        <Typography style={{ textAlign: 'start', marginTop: 10 }} >Angela Zhakir</Typography>
                                        <Typography style={{ textAlign: 'start', marginTop: 10 }} >16 Sep 2020, 13:15 - 13:30</Typography>
                                        <Typography style={{ textAlign: 'start', marginTop: 10 }} >Radang Tenggorokan</Typography>
                                    </div>
                                </div>
                                <div
                                    onClick={() => setStatus(false)}
                                    style={{ height: 30, width: 180, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', margin: 'auto', marginTop: 40, }} >
                                    <Typography style={{ color: 'white', fontSize: 18, textAlign: 'center', margin: 'auto' }}>Tutup</Typography>
                                </div>
                            </div>
                        </div>
                        : null
                }
                {
                    visibleListPoli ?
                        <div className="App app-popup-show">
                            <div className="popup-content background-white" style={{ height: '100%', position: 'absolute', right: 0, width: '33%' }}>
                                <div className="popup-panel grid grid-2x" style={{ height: 64, backgroundColor: '#278863' }}>
                                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                        <div className="popup-title">
                                            <span style={{ color: 'white', fontSize: 18, }}>List Poliklinik</span>
                                        </div>
                                    </div>
                                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                        <button
                                            type="button"
                                            className="btn btn-circle btn-white"
                                            onClick={() => handleClose()}
                                        >
                                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    {
                                        dataPoli && dataPoli.map((el, idx) => {
                                            return (
                                                <div style={{ display: 'block' }}>
                                                    <div style={{ display: 'flex', marginTop: 20, borderBottom: '1px solid #ebebeb' }}>
                                                        <img src={el.media_path} style={{ width: 30, height: 30 }} />
                                                        <Typography>{el.name}</Typography>
                                                        <CustomCheckbox
                                                            checked={el.checked}
                                                            onChange={() => handleCheked(idx)}
                                                            style={{ position: 'absolute', right: 0 }}
                                                        />
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                        : null
                }

                {
                    visibleEmergency ?
                        <div className="App app-popup-show">
                            <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                                <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                    <div className="col-1" />
                                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                        <button
                                            type="button"
                                            className="btn btn-circle btn-white"
                                            onClick={() => onClose()}
                                        >
                                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                        </button>
                                    </div>
                                </div>
                                <div style={{ padding: 20 }}>
                                    <Typography style={{ textAlign: 'left', fontSize: 16 }}>Tombol ini hanya untuk pasien keadaan darurat dan harus di tangani lebih dulu, apakah anda yakin? </Typography>
                                </div>
                                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                    <div className="column-1" style={{ alignSelf: 'center' }}>
                                    </div>
                                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <div
                                            onClick={() => onClose()}
                                            style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                        </div>
                                        <div
                                            onClick={() => submitEmergency()}
                                            style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null
                }
                {
                    visibleCheckIn ?
                        <div className="App app-popup-show">
                            <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                                <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                    <div className="col-1" />
                                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                        <button
                                            type="button"
                                            className="btn btn-circle btn-white"
                                            onClick={() => onClose()}
                                        >
                                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                        </button>
                                    </div>
                                </div>
                                <div style={{ padding: 20 }}>
                                    <Typography style={{ textAlign: 'left', fontSize: 16 }}>Check In Pasien, Anda Yakin? </Typography>
                                </div>
                                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                    <div className="column-1" style={{ alignSelf: 'center' }}>
                                    </div>
                                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <div
                                            onClick={() => onClose()}
                                            style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                        </div>
                                        <div
                                            onClick={() => submitCheckIn()}
                                            style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null
                }
                {
                    visibleCheckInReservation ?
                        <div className="App app-popup-show">
                            <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                                <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                    <div className="col-1" />
                                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                        <button
                                            type="button"
                                            className="btn btn-circle btn-white"
                                            onClick={() => onClose()}
                                        >
                                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                        </button>
                                    </div>
                                </div>
                                <div style={{ padding: 20 }}>
                                    <Typography style={{ textAlign: 'left', fontSize: 16 }}>Check In dan Registrasi Pasien, Anda Yakin? </Typography>
                                </div>
                                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                    <div className="column-1" style={{ alignSelf: 'center' }}>
                                    </div>
                                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <div
                                            onClick={() => onClose()}
                                            style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                        </div>
                                        <div
                                            onClick={() => submitCheckInDanRegis()}
                                            style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null
                }
                {
                    visibleBatal ?
                        <div className="App app-popup-show">
                            <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                                <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                    <div className="col content-left" style={{ width: 400, alignSelf: 'center', }}>
                                        <Typography>Batal Reservasi</Typography>
                                    </div>
                                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                        <button
                                            type="button"
                                            className="btn btn-circle btn-white"
                                            onClick={() => onClose}
                                        >
                                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                        </button>
                                    </div>
                                </div>
                                <div style={{ padding: 20 }}>
                                    <TextField
                                        label="Alasan Batal"
                                        value={alasanBatal}
                                        style={{ width: '90%' }}
                                        placeholder="input alasan batal"
                                        onChange={(e) => {
                                            setAlasanBatal(e.target.value)
                                            forceUpdate()
                                        }}
                                    />
                                </div>
                                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                    <div className="column-1" style={{ alignSelf: 'center' }}>
                                    </div>
                                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <div
                                            onClick={() => onClose()}
                                            style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                        </div>
                                        <div
                                            onClick={() => changeStatus()}
                                            style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null
                }

                {
                    error && (
                        <div className="App app-popup-show">
                            <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                                {/* <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            
                        </div> */}
                                <div style={{ padding: 20 }}>
                                    <Typography style={{ textAlign: 'left', fontSize: 16 }}>{errorMessage}</Typography>
                                </div>
                                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                    <div className="column-1" style={{ alignSelf: 'center' }}>
                                    </div>
                                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        {/* <div
                                    onClick={() => setError(false)}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Ok</Typography>
                                </div> */}
                                        <div
                                            onClick={() => setError(false)}
                                            style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }

                {
                    errorForce && (
                        <div className="App app-popup-show">
                            <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                                {/* <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            
                        </div> */}
                                <div style={{ padding: 20 }}>
                                    <Typography style={{ textAlign: 'left', fontSize: 16 }}>{errorMessage}</Typography>
                                </div>
                                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                    <div className="column-1" style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                        <div
                                            onClick={() => setErrorForce(false)}
                                            style={{ height: 32, width: 150, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                        </div>
                                    </div>
                                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <div
                                            onClick={() => handleForceReschedule()}
                                            style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
        </div >
    )
}